import { ChipTypes } from '@pp/core/src/store/slices/chips/types';
import type { BetInfo } from '@pp/core/src/store/slices/launcher/types';

export class BetsInfoBaseController {
  private betsInfo: BetInfo = {};

  private ensureTableExists(tableId: string): void {
    if (!this.betsInfo[tableId]) {
      this.betsInfo[tableId] = {
        betAmount: 0,
        actualBetAmount: 0,
        isBetClosed: false,
        betType: ChipTypes.CasinoChip,
        bonusId: 0,
        winAmount: 0,
      };
    }
  }

  setBetAmount(tableId: string, betAmount: number, betType: ChipTypes = ChipTypes.CasinoChip, bonusId: number): void {
    this.ensureTableExists(tableId);
    this.betsInfo[tableId] = {
      ...this.betsInfo[tableId],
      betAmount,
      actualBetAmount: betAmount,
      betType,
      bonusId,
    };
  }

  resetAmountsAfterBalanceFetch(): void {
    Object.values(this.betsInfo).forEach((betInfo) => {
      betInfo.betAmount = betInfo.isBetClosed && betInfo.betType === ChipTypes.CasinoChip ? 0 : betInfo.betAmount;
      betInfo.isBetClosed = betInfo.betType === ChipTypes.CasinoChip ? false : betInfo.isBetClosed;
      betInfo.winAmount = 0;
    });
  }

  resetBetAmountsAfterBonusCampaignFetch(): void {
    Object.values(this.betsInfo).forEach((betInfo) => {
      betInfo.betAmount = betInfo.isBetClosed && betInfo.betType === ChipTypes.FreeChip ? 0 : betInfo.betAmount;
      betInfo.isBetClosed = betInfo.betType === ChipTypes.FreeChip ? false : betInfo.isBetClosed;
    });
  }

  setBetClosed(tableId: string, isBetClosed: boolean): void {
    this.ensureTableExists(tableId);
    this.betsInfo[tableId].isBetClosed = isBetClosed;
  }

  setNewTable(table: string | string[]): void {
    const tableIds = Array.isArray(table) ? table : [table];
    tableIds.forEach((tableId) => this.ensureTableExists(tableId));
  }

  deleteTable(tableId: string): void {
    delete this.betsInfo[tableId];
  }

  deleteAllTablesExcept(keepTableIds: string[]): void {
    Object.keys(this.betsInfo).forEach((tableId) => {
      if (!keepTableIds.includes(tableId)) {
        delete this.betsInfo[tableId];
      }
    });
  }

  getAllBetsInfo(): BetInfo {
    return this.betsInfo;
  }

  setWinAmount(tableId: string, winAmount: number): void {
    this.ensureTableExists(tableId);
    this.betsInfo[tableId].winAmount = winAmount;
  }
}

export const BetsInfoController = new BetsInfoBaseController();
